import { Typography, useTheme } from "@mui/material";
import { useLocation } from "react-router-dom";
import { APP_VERSION } from "../../constant";

const HEADER_APP_PREFIXES = [
  "/dashboard",
  "/interviews",
  "/user-management",
  "/candidates",
  "/email-activity",
];

export const usesAppHeader = (pathname) =>
  HEADER_APP_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );

/** Scroll padding (version lives in header on all breakpoints). */
export const appVersionScrollPadding = {
  xs: 0,
  sm: 0,
  md: 0,
};

export const AppVersionLabel = ({ compact = false, sx = {} }) => {
  const theme = useTheme();

  return (
    <Typography
      component="span"
      variant="caption"
      aria-label={`Application version ${APP_VERSION}`}
      sx={{
        color: theme.palette.text.disabled,
        fontWeight: 500,
        fontSize: compact ? "0.8rem" : "0.85rem",
        letterSpacing: 0.2,
        lineHeight: 1.2,
        whiteSpace: "nowrap",
        userSelect: "none",
        ...sx,
      }}
    >
      {compact ? `V${APP_VERSION}` : `Version ${APP_VERSION}`}
    </Typography>
  );
};

/** Header routes show version in toolbar; other routes use compact fixed corner. */
const AppVersion = () => {
  const theme = useTheme();
  const location = useLocation();
  const inHeaderApp = usesAppHeader(location.pathname);

  if (inHeaderApp) return null;

  return (
    <AppVersionLabel
      compact
      sx={{
        position: "fixed",
        right: 8,
        bottom: `calc(${theme.spacing(1)} + env(safe-area-inset-bottom, 0px))`,
        zIndex: 1,
        pointerEvents: "none",
      }}
    />
  );
};

export default AppVersion;
